<template>
  <footer class="secondary">
    <div class="px-4 pt-9 pb-7">
      <v-container
        class="footer-section-top justify-center justify-space-sm-between"
      >
        <div>
          <div
            class="mb-4 font-weight-bold white--text text-body-1 text-uppercase"
          >
            {{ about.title }}
          </div>
          <div
            class="ck-content grey--text text--lighten-3 text-body-2"
            v-html="about.text"
          ></div>
        </div>
        <div>
          <div class="mb-4 font-weight-bold text-body-1 white--text">MENU</div>
          <ul class="footer-list">
            <router-link
              v-for="({ text, to }, i) in menu"
              :key="i"
              :to="to"
              class="d-block text-decoration-none mb-3 mr-5"
            >
              <li
                class="grey--text text--lighten-2 text-body-2 text-capitalize"
              >
                {{ text }}
              </li>
            </router-link>
          </ul>
        </div>
        <div>
          <div class="mb-4 font-weight-bold text-body-1 white--text">
            CATEGORIAS
          </div>
          <ul class="footer-list two-columns">
            <router-link
              v-for="({ text, to }, i) in categories"
              :key="i"
              :to="to"
              class="d-block text-decoration-none mb-3 mr-5"
            >
              <li
                class="grey--text text--lighten-2 text-body-2 text-capitalize"
              >
                {{ text }}
              </li>
            </router-link>
          </ul>
        </div>
        <div>
          <div class="mb-4 font-weight-bold white--text text-body-1">
            INFORMAÇÕES DE CONTATO
          </div>
          <div class="footer-contact d-flex flex-column">
            <div
              v-for="({ title, link, icon }, i) in contact"
              :key="i"
              class="d-flex align-center"
            >
              <v-btn
                :href="link"
                target="_blank"
                color="white"
                class="mr-2"
                small
                icon
              >
                <v-icon size="18">{{ icon }}</v-icon>
              </v-btn>
              <a
                class="
                  text-body-2
                  grey--text
                  text--lighten-3 text-decoration-none
                "
                :href="link"
                target="_blank"
                >{{ title }}</a
              >
            </div>
            <div class="d-flex align-center">
              <v-btn color="white" class="mr-2" small icon @click="showPrivacy">
                <v-icon size="18"> fa fa-shield </v-icon>
              </v-btn>
              <a
                class="text-body-2 white--text text-decoration-none"
                @click="showPrivacy"
              >
                Política de Privacidade
              </a>
            </div>
          </div>
        </div>
      </v-container>
    </div>
    <v-sheet
      min-height="45px"
      class="d-flex align-center"
      color="secondary darken-1 py-2"
    >
      <v-container
        class="
          white--text
          d-flex
          justify-space-between
          align-center
          flex-column flex-sm-row
        "
      >
        <div class="text-body-2 text-center text-uppercase text-caption">
          <span> © 2021 {{ informations.name }}. </span>
          <span> Todos os Direitos Reservados. </span>
        </div>
        <a href="https://mrxweb.com.br/" target="_blank" class="d-flex">
          <img
            class="logo-mrx filter-white mt-4 mt-sm-0"
            src="/img/mrx.svg"
            alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
          />
        </a>
      </v-container>
    </v-sheet>
  </footer>
</template>

<script>
import { formatToURL } from "@/components/utils.js";
import { getContact, menu } from "@/config.js";

export default {
  data: () => ({
    menu,
  }),
  computed: {
    categories() {
      return this.$rest("articles-categories").list.map(({ title }) => ({
        text: title,
        to: `/noticias/${formatToURL(title)}`,
      }));
    },
    informations() {
      return this.$rest("informations").item;
    },
    about() {
      return this.$rest("about").item;
    },
    contact() {
      return getContact(this);
    },
  },
  methods: {
    showPrivacy: () => window.showPrivacyPolicy(),
  },
};
</script>

<style>
.footer-section-top {
  display: grid;
  grid-template-columns: auto min-content min-content min-content;
  column-gap: 60px;
  row-gap: 20px;
}
.logo-mrx {
  height: 20px;
}
.footer-contact {
  gap: 16px;
}

.two-columns {
  column-count: 2;
}
.footer-list li {
  white-space: nowrap;
}
.footer-list li::marker {
  font-size: 20px;
}
.footer-list li:hover {
  font-weight: bold;
}
.footer-list li:hover::marker {
  color: white;
}

@media screen and (max-width: 1264px) {
  .footer-section-top {
    grid-template-columns: 1fr 1fr;
  }
  .footer-section-top > :nth-child(4) {
    grid-row-start: 1;
    grid-column-start: 2;
  }
}

@media screen and (max-width: 600px) {
  .footer-section-top {
    grid-template-columns: 1fr;
  }
  .footer-section-top > :nth-child(4) {
    grid-row-start: initial;
    grid-column-start: initial;
  }
}
</style>
